var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-referral-solutions-item"},[(_vm.title)?_c('div',{staticClass:"plugin-referral-solutions-item__title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),(_vm.description)?_c('div',{staticClass:"plugin-referral-solutions-item__description",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }